var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
/**
 * A utility to conditionally warp children in a given React component.
 *
 * @example
 *
 * <ConditionalWrapper
 *    wrapIf={isVertical}
 *    wrapper={FixedSticky}
 *    wrapperProps={{offset: { top: 100 }}}
 * >
 *  <div>children</div>
 * </ConditionalWrapper>
 */
export function ConditionalWrapper(_a) {
    var wrapIf = _a.wrapIf, Wrapper = _a.wrapper, wrapperProps = _a.wrapperProps, children = _a.children;
    if (!wrapIf) {
        return children;
    }
    return React.createElement(Wrapper, __assign({}, wrapperProps), children);
}
